import React from "react";
import "./stepOne.scss";

// Imagens:
import ImgStepOne from "../../../../assets/homeImgs/stepOne.png";
import { useTranslation } from "react-i18next";

const StepOne = () => {
  const {t} =  useTranslation()

  return (
    <div className="container-step-one">

      <div className="img-step-one">
        <img src={ImgStepOne} alt="imagem step um" />
      </div>
      <div className="texts-step-one">
        <h1>1. {t("home.step1.title")}</h1>
        <p>{t("home.step1.section_text")}</p>
        {/* <button id="btn-step-one">CONFIRA!</button> */}
      </div>
    </div>
  );
};
export default StepOne;
